import { render, staticRenderFns } from "./PatientsDoctor.vue?vue&type=template&id=62216d43&scoped=true&"
import script from "./PatientsDoctor.vue?vue&type=script&lang=js&"
export * from "./PatientsDoctor.vue?vue&type=script&lang=js&"
import style0 from "./PatientsDoctor.vue?vue&type=style&index=0&id=62216d43&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62216d43",
  null
  
)

export default component.exports